import MaterialTable from "material-table";
import tableicons from "../tableicons";
import React from "react";
import {ajustesResources, ValidacionConteoResources} from "../endpoints";
import SnackbarAlert from "../components/SnackbarAlert";
import {Link} from "react-router-dom";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import useToken from "../useToken";

class ValidacionConteo extends React.Component{
    constructor(props) {
        let datos_inv = useToken.getDatos()
        super(props);
        this.state={
            valores : [],
            openSnack:false,
            severity: null,
            message:null,
            cargando:true,
            titulo_columna : (datos_inv.app === 'sodimac'? 'Costo':'Importe'),
        }
    }

    getValoresValidacion = () =>{
        ValidacionConteoResources.getValores().then(async response => {
            if (response.ok) {
                return await response.json();
            } else {
                throw new Error('Something went wrong ...');
            }
        }).then(result => {
            this.setState({valores:result,cargando:false})
        }).catch(error=> {
            console.log(error)
        });
    }

    modificarCantidadConteo = (id,cantidad) =>{
        ajustesResources.ajustarCantidadValidacion(id,cantidad, 1).then(async response => {
            if (response) {
                return await response.json();
            }
        }).then(result => {
            if(result.message){
                this.refrescar(result.message,result.severity)
            }
            else{
                throw new Error('Something went wrong ...');
            }
        }).catch(error=> {
            this.refrescar("Ha ocurrido un error inesperado","error")
            console.log(error)
        });
    }

    refrescar = (estado,severity) =>{
        this.setState({openSnack:false, severity: null, message:null}, ()=>{
            if(severity === "success"){
                this.getValoresValidacion()
            }
            this.setState({openSnack:true, severity:severity, message:estado})
        })

    }

    componentDidMount() {
        this.getValoresValidacion();
    }

    render() {
        return (
            <div>
                <Typography variant="h4" gutterBottom>
                    Validación conteo
                </Typography>
                <div style={{display: 'flex',justifyContent: 'end'}}>
                    <Link to={"/resumen_validacion"} style={{color: '#000000', textDecoration: 'none'}}>
                        <Button size="large" variant="contained" color="primary">
                            Ver resumen
                        </Button>
                    </Link>
                </div>

                <br/>
                <MaterialTable
                    localization={{
                        toolbar: {
                            searchPlaceholder: 'Buscar',
                            nRowsSelected: "{0} registro(s) seleccionado(s)"
                        },
                        body:{
                            emptyDataSourceMessage: 'No hay datos para mostrar'
                        },
                        pagination:{
                            firstAriaLabel: 0,
                        },
                        header: {
                            actions: 'Acciones',
                            sizeActions:"large"
                        },
                    }}
                    options={{
                        pageSize: 50,
                        pageSizeOptions: [10, 25, 50, 100],
                        actionsColumnIndex: -1,
                        searchFieldStyle: {
                            width: "auto",
                        },
                        padding: "dense",
                        rowStyle: rowData => ({
                            backgroundColor: (this.state.selectedRow === rowData.tableData.id) ? '#dbe9fc' :  (rowData.dif === 0 && rowData.revisado) ? '#81c784' : (rowData.cant_inv === 0 && !rowData.revisado) ? '#e57373' : '#ffd54f'
                        }),
                    }}
                    cellEditable={{
                        onCellEditApproved: (newValue, oldValue, rowData, columnDef) => {
                            return new Promise((resolve, reject) => {

                                let valor = newValue.toString().trim().replace(/,/g, ".");
                                const numero = Number(valor);

                                // ❌ no es número
                                if (!Number.isFinite(numero)) {
                                    this.setState({ openSnack: false }, () => {
                                        this.setState({
                                            openSnack: true,
                                            severity: 'error',
                                            message: 'Ingrese un número válido'
                                        });
                                    });

                                    reject();
                                    return;
                                }

                                // ❌ decimal en UN
                                if (rowData.un === "UN" && !Number.isInteger(numero)) {
                                    this.setState({ openSnack: false }, () => {
                                        this.setState({
                                            openSnack: true,
                                            severity: 'error',
                                            message: 'La unidad "UN" solo permite números enteros'
                                        });
                                    });

                                    reject();
                                    return;
                                }

                                // ✅ válido
                                const datos = [...this.state.valores];
                                const index = datos.indexOf(rowData);

                                datos[index].cant_inv = numero;

                                this.setState({ valores: datos });

                                resolve();

                                this.modificarCantidadConteo(rowData.id, numero);
                            });
                        },
                    }}
                    onRowClick={(event, rowData) => this.setState({selectedRow: rowData.tableData.id})}
                    isLoading={this.state.cargando}
                    icons={tableicons}
                    title= ""
                    data={this.state.valores}
                    columns={[
                        { title: 'Material', field: 'articulo',
                            editable:"never",
                            cellStyle: {
                                width: 200,
                                maxWidth: 200,
                            },
                            headerStyle: {
                                width: 200,
                                maxWidth: 200,
                            }
                        },
                        { title: 'Código', field: 'barra',
                            editable:"never",
                            cellStyle: {
                                width: 200,
                                maxWidth: 200,
                            },
                            headerStyle: {
                                width: 200,
                                maxWidth: 200,
                            }
                        },
                        { title: 'Descripcion', field: 'descripcion',
                            editable:"never",
                            cellStyle: {
                                width: 400,
                                maxWidth: 400,
                            },
                            headerStyle: {
                                width: 400,
                                maxWidth: 400
                            }
                        },
                        { title: 'UN', field: 'un',
                            editable:"never",
                            cellStyle: {
                                width: 200,
                                maxWidth: 200,
                            },
                            headerStyle: {
                                width: 200,
                                maxWidth: 200
                            }
                        },
                        { title: 'Precio', field: 'precio',
                            editable:"never",
                            render: (rowData => new Intl.NumberFormat("de-DE").format(rowData.precio)),
                            customFilterAndSearch: ((term, rowData) => new Intl.NumberFormat("de-DE").format(rowData.precio).indexOf(term) !== -1),
                            cellStyle: {
                                width: 200,
                                maxWidth: 200,
                            },
                            headerStyle: {
                                width: 200,
                                maxWidth: 200
                            }
                        },
                        { title: 'Tag', field: 'tag',
                            editable:"never",
                            customSort: (a, b) => parseInt(a.tag) - parseInt(b.tag) ,
                            defaultSort: "asc",
                            cellStyle: {
                                width: 200,
                                maxWidth: 200,
                                fontWeight: "bold"
                            },
                            headerStyle: {
                                width: 200,
                                maxWidth: 200,
                                fontWeight: "bold"
                            }
                        },
                        { title: 'Cantidad teo.', field: 'cant_teo',
                            editable:"never",
                            render: rowData =>
                            new Intl.NumberFormat("de-DE", {
                                maximumFractionDigits: 10
                            }).format(rowData.cant_teo),
                            customFilterAndSearch: ((term, rowData) => new Intl.NumberFormat("de-DE",{
                                maximumFractionDigits: 10
                            }
                            ).format(rowData.cant_teo).indexOf(term) !== -1),
                            cellStyle: {
                                width: 200,
                                maxWidth: 200,
                            },
                            headerStyle: {
                                width: 200,
                                maxWidth: 200
                            }
                        },
                        { title: 'Cantidad inv.', field: 'cant_inv',
                            render: (rowData => new Intl.NumberFormat("de-DE", {
                                maximumFractionDigits: 10
                            }).format(rowData.cant_inv)),
                            customFilterAndSearch: ((term, rowData) => new Intl.NumberFormat("de-DE", {
                                maximumFractionDigits: 10
                            }).format(rowData.cant_inv).indexOf(term) !== -1),
                            cellStyle: {
                                width: 200,
                                maxWidth: 200,
                            },
                            headerStyle: {
                                width: 200,
                                maxWidth: 200
                            }
                        },
                        { title: 'Diferencia', field: 'dif',
                            editable:"never",
                            render: (rowData => new Intl.NumberFormat("de-DE", {
                                maximumFractionDigits: 10
                            }).format(rowData.dif)),
                            customFilterAndSearch: ((term, rowData) => new Intl.NumberFormat("de-DE", {
                                maximumFractionDigits: 10
                            }).format(rowData.dif).indexOf(term) !== -1),
                            cellStyle: {
                                width: 200,
                                maxWidth: 200,
                            },
                            headerStyle: {
                                width: 200,
                                maxWidth: 200
                            }
                        },
                        { title: this.state.titulo_columna, field: 'impinv',
                            editable:"never",
                            render: (rowData => new Intl.NumberFormat("de-DE", {
                                maximumFractionDigits: 3
                            }).format(rowData.impinv)),
                            customFilterAndSearch: ((term, rowData) => new Intl.NumberFormat("de-DE", {
                                maximumFractionDigits: 3
                            }).format(rowData.impinv).indexOf(term) !== -1),
                            cellStyle: {
                                width: 200,
                                maxWidth: 200,
                            },
                            headerStyle: {
                                width: 200,
                                maxWidth: 200
                            }
                        },
                        { title: 'Dif. ' + this.state.titulo_columna, field: 'difimp',editable:'never',  type: 'numeric',
                            render: (rowData => new Intl.NumberFormat("de-DE", {
                                maximumFractionDigits: 3
                            }).format(rowData.difimp)),
                            customFilterAndSearch: ((term, rowData) => new Intl.NumberFormat("de-DE", {
                                maximumFractionDigits: 3
                            }).format(rowData.difimp).indexOf(term) !== -1),
                        },
                    ]}
                />
                {this.state.openSnack? <SnackbarAlert severity={this.state.severity} message={this.state.message}/> : null}
            </div>
        )
    }
}

export default ValidacionConteo;